import cn from 'classnames'
import { uniqueId } from 'lodash'
import React from 'react'
import { useMediaQuery } from '@mui/material'
import { ReactComponent as CalcOfFiles } from '../../../../assets/icons/calcOfFiles.svg'
import { ReactComponent as CloseSvg } from '../../../../assets/icons/closeIcon.svg'
import FileList from '../../FileList/FileList'
import styles from '../../UserCard.module.scss'
import UserCardSmartTooltip from '../../UserCardSmartTooltip/UserCardSmartTooltip'

const LicenseItem = ({ title, licenseFiles, endorsementFiles, items }) => {
  const [showFileList, setShowFileList] = React.useState(false)
  const isCompactView = useMediaQuery('(max-width:1199.98px)')

  const filesCount = (endorsementFiles?.length || 0) + (licenseFiles?.length || 0)
  const licenseItems = items?.slice(0, 3) || []
  const endorsementItems = items?.slice(3) || []

  return (
    <div className={styles.contentItem}>
      {isCompactView ? (
        <div className={styles.header}>
          <UserCardSmartTooltip
            id={uniqueId('license-item-')}
            type={'simple'}
            title={title}
            titleClass={styles.contentItemTitle}
          />

          {!showFileList && (
            <div
              className={cn(styles.calcOfFilesContainer, { [styles.calcOfActive]: showFileList })}
              onClick={() => {
                filesCount && setShowFileList(!showFileList)
              }}
            >
              <label className={styles.calcOfFilesContainerLabel}>Photo</label>
              <div className={styles.calcOfFiles}>
                <CalcOfFiles />
                <label className={styles.calcOfFilesLabel}>{filesCount}</label>
              </div>
            </div>
          )}

          {showFileList && (
            <button
              className={styles.closeBtn}
              onClick={() => {
                setShowFileList(false)
              }}
            >
              Close
              <CloseSvg />
            </button>
          )}
        </div>
      ) : (
        <div className={cn(styles.header, { [styles.license]: true })}>
          <UserCardSmartTooltip
            id={uniqueId('license-item-')}
            type={'simple'}
            title={title}
            titleClass={styles.contentItemTitle}
          />

          <div className={styles.endorsementTitleContainer}>
            <h3 className={styles.endorsementTitle}>Endorsement</h3>
            {!showFileList && (
              <div
                className={cn(styles.calcOfFilesContainer, { [styles.calcOfActive]: showFileList })}
                onClick={() => {
                  filesCount && setShowFileList(!showFileList)
                }}
              >
                <label className={styles.calcOfFilesContainerLabel}>Photo</label>
                <div className={styles.calcOfFiles}>
                  <CalcOfFiles />
                  <label className={styles.calcOfFilesLabel}>{filesCount}</label>
                </div>
              </div>
            )}
            {showFileList && (
              <button
                className={styles.closeBtn}
                onClick={() => {
                  setShowFileList(false)
                }}
              >
                Close
                <CloseSvg />
              </button>
            )}
          </div>
        </div>
      )}

      <div className={cn(styles.body, { [styles.license]: !isCompactView })}>
        {isCompactView ? (
          <>
            <div className={styles.licenseSectionTitle}>License:</div>
            {licenseItems.map((item, index) => (
              <UserCardSmartTooltip
                key={`license-${index}`}
                title={item.title}
                value={item.value}
                id={uniqueId('license-item-')}
                containerClass={styles.item}
                titleClass={styles.itemTitle}
                valueClass={styles.itemValue}
              />
            ))}

            <div className={styles.licenseSectionTitle}>Endorsement:</div>
            {endorsementItems.map((item, index) => (
              <UserCardSmartTooltip
                key={`endorsement-${index}`}
                title={item.title}
                value={item.value}
                id={uniqueId('license-item-')}
                containerClass={styles.item}
                titleClass={styles.itemTitle}
                valueClass={styles.itemValue}
              />
            ))}
          </>
        ) : (
          items?.map((item, index) => (
            <UserCardSmartTooltip
              key={index}
              title={item.title}
              value={item.value}
              id={uniqueId('license-item-')}
              containerClass={styles.item}
              titleClass={styles.itemTitle}
              valueClass={styles.itemValue}
            />
          ))
        )}

        {licenseFiles?.length || endorsementFiles?.length ? (
          <>
            <FileList files={licenseFiles} showFiles={showFileList} type={'license'} />
            <FileList files={endorsementFiles} showFiles={showFileList} type={'endorsement'} />
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default LicenseItem
